import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import Button from '@/components/Button';
import { DialogFooter, DialogTop } from '@/components/Dialog';
import Print from '@/icons/print.svg';
import transactionModel from '@/models/transaction';
import { showError, showSuccess } from '@/utils';

function PrintDocumentContent({ id, onOpenChange, selectedTransactions }) {
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);

	const handlePrintDocument = async () => {
		try {
			setLoading(true);
			const url = transactionModel.downloadUrl(
				selectedTransactions?.[0].id || id,
				'pdf'
			);

			const response = await fetch(url);
			const iframe = document.createElement('iframe');
			iframe.style.display = 'none';

			const blob = await response.blob();
			const urlBlob = URL.createObjectURL(blob);
			iframe.src = urlBlob;
			document.body.appendChild(iframe);
			iframe.contentWindow.print();
			onOpenChange(false);
			setLoading(false);
			showSuccess(t('myDocuments.toast.printDocumentSuccess'));
		} catch (error) {
			showError(error);
			setLoading(false);
		}
	};

	return (
		<>
			<DialogTop
				title={t('myDocuments.modals.printDocument.title')}
				description={t('myDocuments.modals.printDocument.description')}
			/>

			<div className="flex flex-col items-center gap-2 px-4 py-9">
				<Print className="h-5 w-5 text-red" />
				<p className="whitespace-pre-line text-center text-sm text-grey-500">
					{t('myDocuments.modals.printDocument.text')}
				</p>
			</div>

			<DialogFooter>
				<Button variant="outline" onClick={() => onOpenChange(false)}>
					{t('common.cancel')}
				</Button>
				<Button onClick={handlePrintDocument} loading={loading}>
					{t('common.print')}
				</Button>
			</DialogFooter>
		</>
	);
}

export default PrintDocumentContent;
